import Login from '../views/authentication/login';

var authRoutes = [
    { path: '/auth/login', name: 'Login', icon: 'mdi mdi-account-key', component: Login }
];
export default authRoutes; 